import { useCurrencyAmountFormatter } from '@routable/shared';
import React from 'react';
import { CurrencyCode } from 'constants/currency';
const ExternalItemsListAmount = ({ rowData }) => {
    const { formatCurrencyAmount } = useCurrencyAmountFormatter();
    return (React.createElement("span", { className: "like-p company" }, formatCurrencyAmount({ amount: rowData.amount, currency: CurrencyCode.USD })));
};
export default ExternalItemsListAmount;
